import { render, staticRenderFns } from "./PublicDel.vue?vue&type=template&id=49a4a794&"
import script from "./PublicDel.vue?vue&type=script&lang=js&"
export * from "./PublicDel.vue?vue&type=script&lang=js&"
import style0 from "./PublicDel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports